<template>
  <v-btn
    @click="open"
    color="blue"
    class="my-2 white--text"
    small
    depressed
    :loading="isOpening"
    :disabled="disabled"
  >
    <template v-if="remainingLimit && limit === 1">
      Add a Photo
    </template>
    <template v-else-if="remainingLimit && limit">
      Add Up To {{ remainingLimit }}
      {{ remainingLimit !== limit ? 'More ' : '' }}Photo{{
        remainingLimit > 1 ? 's' : ''
      }}</template
    >
    <template v-else>Can't Add More Photos</template>
  </v-btn>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _get from 'lodash/get'

export default {
  name: 'UploadWidget',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: null,
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpening: false,
    }
  },
  methods: {
    ...mapActions('admin', ['setUploadWidget']),
    async open() {
      this.isOpening = true
      if (this.getUploadWidget) {
        this.getUploadWidget.update({
          multiple: this.remainingLimit > 1,
          maxFiles: this.remainingLimit || undefined,
        })
        this.initWidget()
      } else {
        this.setUploadWidget(this.initWidget())
      } // setuploadwidget
    }, // open
    initWidget() {
      return window.cloudinary.openUploadWidget(
        {
          cloudName: 'resto',
          uploadPreset: 'minimart',
          folder: `minimart/users/${this.getShopId}`,
          resourceType: 'image',
          multiple: this.limit ? this.remainingLimit > 1 : true,
          maxFiles: this.limit ? this.remainingLimit : undefined,
          maxImageWidth: 1500,
          maxImageHeight: 1500,
          thumbnailTransformation: 'h_200,c_scale,f_auto',
          showCompletedButton: false,
        },
        (error, result) => {
          const eventData = result.data
          const eventName = _get(eventData, 'event')
          if (eventName === 'display-changed') {
            this.isOpening = false
          }
          if (eventName === 'queues-end') {
            // console.log({ eventData })

            // // if multiple is set to false, we need to mock an array
            // // so we can iterate
            // let files = eventData.info.files || [eventData.info.file]
            let uploads = eventData.info.files.map((item) => {
              return {
                url: item.uploadInfo.url,
                asset_id: item.uploadInfo.asset_id,
                public_id: item.uploadInfo.public_id,
                thumb: item.uploadInfo.thumbnail_url,
                path: item.uploadInfo.path,
                caption: '',
              }
            })

            this.$emit('uploaded', uploads)
          }
          if (eventName === 'success') {
            // console.log('✅ Success', { eventData })
          }
          if (eventName === 'abort') {
            this.isOpen = false
            // console.log('✅ Success', { eventData })
          }
        }
      )
    }, // initWidget
  }, // methods
  computed: {
    ...mapGetters('admin', ['getUploadWidget']),
    ...mapGetters('shop', ['getShopId']),
    remainingLimit() {
      return this.limit - this.files.length
    }, // remainingLimit
  },
}
</script>
